import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';

import { TranslateModule } from '@ngx-translate/core';

import { ContentComponent } from './content/content.component';
import { HeaderBaseComponent } from './header-base/header-base.component';
import { FooterBaseComponent } from './footer-base/footer-base.component';
import { SaveSheetComponent } from './save-sheet/save-sheet.component';
import { HeaderButtonDirective } from './header-base/header-button/header-button.directive'

@NgModule({
  declarations: [HeaderBaseComponent, FooterBaseComponent, ContentComponent, SaveSheetComponent, HeaderButtonDirective],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatBadgeModule,
    TranslateModule,
  ],
  exports: [HeaderBaseComponent, FooterBaseComponent, HeaderButtonDirective]
})
export class NavigationModule { }
